export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
  /** Show the label next to the switch (otherwise only as accessible name). */
  showLabel?: boolean;
}

export function Switch({ showLabel, label, ...control }: SwitchProps): React.JSX.Element {
  return showLabel ? <LabelledSwitch label={label} {...control} /> : <SwitchControl ariaLabel={label} {...control} />;
}

type SwitchControlProps = Omit<SwitchProps, "showLabel" | "label"> & { ariaLabel?: string };

function SwitchControl({ checked, onChange, disabled, ariaLabel }: SwitchControlProps): React.JSX.Element {
  return (
    <button
      type="button"
      role="switch"
      className="nb-switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    />
  );
}

/** The visible label names the switch, so it needs no aria-label. */
function LabelledSwitch({ label, ...control }: Omit<SwitchProps, "showLabel">): React.JSX.Element {
  return (
    <label className="nb-switch-row">
      <SwitchControl {...control} />
      <span>{label}</span>
    </label>
  );
}
